import Vue from 'vue'
import Vuex from'vuex'
import user from './user.js'

import createPersistedState from "vuex-persistedstate"
Vue.use(Vuex)

export default new Vuex.Store({
	namespace: true,
	modules: {
		user
	},
    plugins:[
		createPersistedState()
	]
	
})
